import React from 'react';
import { observer } from 'mobx-react-lite';
import styles from './blogPostPage.module.sass';
import { Anchor, Text } from '../../Text';
import { PartnersBanners } from '../../Banner/PartnersBanner/PartnersBanners';
import { useBlogStore } from '../../../providers/RootStoreProvider';
import { IconSVG } from '../../SpriteSVG';
import { Icon } from '../../Icon';
import { Image } from '../../Image/Image';
import { resolveUrl } from '../../../utils/resolveUrl';
import { serialize } from '../../../utils/serialize';

export const BlogPostPage = observer(({ isMobile, isTablet, banners }) => {
  const store = useBlogStore();

  const { article } = store;

  const partTwo = [...(article.body ?? [])];

  let i = 0;
  let banner = 0;

  partTwo.forEach(({ type }, index) => {
    if (type === 'heading-two' && i < 4) {
      i++;
      banner = index;
    }
  });

  const partOne = i === 4 ? partTwo.splice(0, banner) : [];

  return (
    <div
      className={styles.container}
      itemScope
      itemType="http://schema.org/BlogPosting"
    >
      <div className={styles.head}>
        <Text
          className={styles.mainTitle}
          component="h1"
          variant="heading-lg"
          itemProp="headline"
        >
          {article?.title}
        </Text>
        <div
          className={styles.mainImage}
          itemScope
          itemType="http://schema.org/ImageObject"
        >
          <Image
            src={`${resolveUrl(article?.photo?.src)}`}
            srcSet={`${resolveUrl(article?.photo?.srcset)}`}
            alt={article?.photo?.alt}
            loading="lazy"
            itemProp="image"
            title={article?.photo?.title}
          />
          <meta itemProp="url" content={resolveUrl(store.data?.photo?.src)} />
        </div>
        <div className={styles.info}>
          <div className={styles.date}>
            <Anchor
              href={`/blog?media=${article?.media.id}`}
              variant="linkAsButtonPrimary"
              itemProp="keywords"
            >
              {article?.media.label}
            </Anchor>
            <Text component="div" variant="text-1" itemProp="datePublished">
              {article?.date}
            </Text>
          </div>
          {!!article.reading_time && (
            <div className={styles.readTime} itemProp="timeRequired">
              <Icon
                width={16}
                height={16}
                rightGap={4}
                icon={<IconSVG name={'common/time'} width={16} height={16} />}
                title="Время чтения статьи"
              />
              <Text component="div" variant="text-1" color="subColor">
                {article.reading_time} мин. на чтение
              </Text>
            </div>
          )}
        </div>
      </div>
      <div className={styles.article} itemProp="articleBody">
        {serialize(partOne)}
        {!!partOne.length && (
          <div className={styles.banner}>
            <PartnersBanners
              isMobile={isMobile}
              isTablet={isTablet}
              banners={banners}
            />
          </div>
        )}

        {serialize(partTwo)}

        {!partOne.length && (
          <div className={styles.banner}>
            <PartnersBanners
              isMobile={isMobile}
              isTablet={isTablet}
              banners={banners}
            />
          </div>
        )}
      </div>

      {/* Автор статьи (если есть) */}
      {/*<div itemProp="author" itemScope itemType="http://schema.org/Person">*/}
      {/*  <meta itemProp="name" content="Имя автора" />*/}
      {/*</div>*/}
      {/* Дата публикации (если отличается от отображаемой) */}
      {/*<meta itemProp="datePublished" content="2023-07-13" />*/}
      {/* Дата последнего изменения (если есть) */}
      {/*<meta itemProp="dateModified" content="2023-07-15" />*/}
    </div>
  );
});
